// extracted by mini-css-extract-plugin
export var caption = "bM_hv";
export var grey = "bM_dq";
export var heading = "bM_G";
export var image = "bM_d";
export var left = "bM_bG";
export var reverse = "bM_dm";
export var right = "bM_bH";
export var section = "bM_b";
export var video = "bM_gs";
export var videoContainer = "bM_cm";
export var videoWrapper = "bM_cn";